import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '../lib/api-client';

export const materialKeys = {
  all: ['materials'] as const,
  lists: () => [...materialKeys.all, 'list'] as const,
  list: (filters: Record<string, unknown> | undefined) =>
    [...materialKeys.all, 'list', { filters }] as const,
  details: () => [...materialKeys.all, 'detail'] as const,
  detail: (id: string) => [...materialKeys.details(), id] as const,
};

export function useMaterials(filters?: { flowId?: string; type?: string }) {
  return useQuery({
    queryKey: materialKeys.list(filters),
    queryFn: () => apiClient.materials.list(filters),
  });
}

export function useMaterial(id: string) {
  return useQuery({
    queryKey: materialKeys.detail(id),
    queryFn: () => apiClient.materials.get(id),
    enabled: !!id,
  });
}

export function useCompleteMaterial() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, enrollmentId }: { id: string; enrollmentId: string }) =>
      apiClient.materials.complete(id, { enrollmentId }),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['enrollments'] });
      await queryClient.invalidateQueries({ queryKey: materialKeys.all });
    },
  });
}
